import { render, staticRenderFns } from "./PointBody.vue?vue&type=template&id=978ab35e&scoped=true&"
import script from "./PointBody.vue?vue&type=script&lang=ts&"
export * from "./PointBody.vue?vue&type=script&lang=ts&"
import style0 from "./PointBody.vue?vue&type=style&index=0&id=978ab35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978ab35e",
  null
  
)

export default component.exports